const config = {
  serverUrl: "https://driveyes.theboxapp.gr"
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/config.js